"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatDecoder = void 0;
const DecodingUtils_1 = require("./DecodingUtils");
class FloatDecoder {
    constructor() { }
    static decodeFloatStream(data, offset, streamMetadata) {
        const values = DecodingUtils_1.DecodingUtils.decodeFloatsLE(data, offset, streamMetadata.numValues());
        const valuesList = new Float32Array(values.length);
        for (let i = 0; i < values.length; i++) {
            valuesList[i] = values[i];
        }
        return valuesList;
    }
}
exports.FloatDecoder = FloatDecoder;
//# sourceMappingURL=FloatDecoder.js.map